import Vue from 'vue';

import './registerServiceWorker';
import './components';
import './styles/index.scss';
import '@/utils/directives';
import '@/utils/mixins/routeDecisions/routeConditionals/routeHelperMixin';
import './utils/helpers/filters/index';
import Toasted from 'vue-toasted';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(Toasted);
Vue.config.productionTip = false;
Vue.use(require('vue-moment'));
Vue.use(router);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
